module.exports = __webpack_public_path__ + "img/more.7948c777.svg";